/**
 * Switch content based on the selected tab.
 */
import React from 'react';

import {envIsPublicCloud} from '../../../config';
import {Analytics} from '../../../services/analytics';
import {TabMonitor} from '../QueueObservability/TabMonitor';
import {Queue} from '../Queues/queueUtil';
import {TabAgents} from './TabAgents';
import {TabConfig} from './TabConfig';
import {TabRuns} from './TabRuns';

type QueueDetailTabContentProps = {
  tab: string;
  queue: Queue;
  onAddAgent: () => void;
  refetchQueue: () => void;
};

export const QueueDetailTabContent = ({
  tab,
  queue,
  onAddAgent,
  refetchQueue,
}: QueueDetailTabContentProps) => {
  Analytics.track(`clicked tab: ${tab}`, {
    tab,
    queue,
    location: 'queue detail',
  });

  return (
    <>
      {tab === 'runs' && <TabRuns queue={queue} refetchQueue={refetchQueue} />}
      {tab === 'agents' && <TabAgents queue={queue} onAddAgent={onAddAgent} />}
      {tab === 'config' && (
        <TabConfig queue={queue} refetchQueue={refetchQueue} />
      )}
      {envIsPublicCloud && tab === 'monitor' && <TabMonitor queue={queue} />}
    </>
  );
};
